import React from "react";
import { Error } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, GridLegacy as Grid, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'





export const ModalShowLogs = ({
    header,
    is_visible,
    onClose
})=>{


    
    const LogData = header.logs?.map(item=>({...(JSON.parse(item.log_data) || {}),id:item.id})) || [];
    console.log(LogData);

    return (
        <Dialog
        open={is_visible}
        >
            <DialogTitle>
              Visualizacion de log de errores
            </DialogTitle>
            <DialogContent>
                <Grid container >
                    <Grid item sx={12} md={12} >
                         <Typography variant="h6" fontSize={16} >Información del plano</Typography>

                    </Grid>
                    <Grid container  item sx={12} md={12} >

                            <Grid item md={6} >
                                <Typography variant="p"> <strong>PROCESO ID:</strong> {header.proceso_ID_GEN}</Typography>
                            </Grid>
                            <Grid item md={6} >
                                <Typography variant="p"> <strong>PROCESO ESTADO:</strong> {header.prceso_estado}</Typography>
                            </Grid>
                            <Grid  item md={12} >
                                <Typography variant="p"> <strong>FECHA DE PROCESO:</strong> {header.prceso_fecha_inicio} / {header.prceso_fecha_fin}</Typography>
                            </Grid>
                            
                            <Grid item md={6} >
                                <Typography variant="p"> <strong>PLANO:</strong> {header.plano_nombre}</Typography>
                            </Grid>
                            <Grid item md={6} >
                                <Typography variant="p"> <strong>ESTADO:</strong> {header.plano_estado}</Typography>
                            </Grid>

                    </Grid>
                    <Grid item sx={12} md={12} >
                         <Typography variant="h6" fontSize={16} >Listado de logs</Typography>

                    </Grid>
                    <Grid item sx={12} md={12} >

                        {
                            LogData.map( logItem=> <ListItem key={logItem.id} alignItems="flex-start">
                            <ListItemAvatar>
                               <Error />
                            </ListItemAvatar>
                            <ListItemText
                                primary={`LINEAS: ${logItem.line} :: CABECERA:${logItem.head}`}
                                secondary={
                                    <>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                           {logItem.error}
                                        </Typography>
                                      <Typography variant="subtitle2" >
                                        {logItem.error_raw}
                                      </Typography>
                                    </>
                                }
                            />
                             <Divider variant="inset" component="li" />
                        </ListItem> )
                        }
                       

                    </Grid>
                </Grid>
                
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" size="small" >Cerrar</Button>
            </DialogActions>
        </Dialog>
    )

}